export default __webpack_public_path__ + "static/pagination-left-arrow-mobile-142a02e386474d99b9133818eabf006f.svg";